// eslint-disable-next-line import/no-anonymous-default-export
export default
{
    SECTION_HOME: 'Home',
    SECTION_TUTORIALS: 'Tutorials',
    SECTION_EMAIL: 'Email',
    SECTION_ELEVIO: 'Elevio',
};
